import { SHOW_CONFIRM_DELETE_MODAL, SHOW_COMMENT_DELETE_CONFIRMATION, SHOW_TEMPLATE_MODAL, ADD_ACTIVE_PLUGIN_ID } from '../constants';

export const showDeleteConfirmationModal = (showModal) => ({
  type: SHOW_CONFIRM_DELETE_MODAL,
  showModal,
});

export const showCommentDeleteConfirmation = (showModal, comment) => ({
  type: SHOW_COMMENT_DELETE_CONFIRMATION ,
  showModal: showModal,
  comment: comment,
});

export const showTemplateModal = (showModal, templateDetail) => ({
  type: SHOW_TEMPLATE_MODAL,
  showModal,
  templateDetail,
});

export const activePluginId = (pluginId) => ({
  type: ADD_ACTIVE_PLUGIN_ID,
  pluginId,
});